(() => {
  if (window.__quickAddCustomInitialized) return;
  window.__quickAddCustomInitialized = true;

  const selectors = {
    component: 'quick-add-component',
    form: '[data-ref="quick-add-form"]',
    variantSelect: '[data-ref="inline-variant-select"]',
    variantInput: '[data-ref="quick-add-variant-id"], [data-quick-add-variant-input], [name="id"]',
    button: '[data-ref="add-to-cart-button"]',
  };

  function getCartAddUrl(form) {
    if (window.Theme?.routes?.cart_add_url) return window.Theme.routes.cart_add_url;
    return `${form.action.replace(/\.js$/, '')}.js`;
  }

  function getSections() {
    const cartDrawer = document.querySelector('cart-drawer');
    const sections = ['auto-gifts'];
    if (cartDrawer?.dataset.sectionId) sections.push(cartDrawer.dataset.sectionId);
    return sections;
  }

  function getCurrentItemCount() {
    const cartIcon = document.querySelector('cart-icon');
    return cartIcon?.getCurrentItemCount?.() || 0;
  }

  function dispatchCartUpdated(data, quantity) {
    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        bubbles: true,
        detail: {
          resource: {},
          data: {
            itemCount: getCurrentItemCount() + quantity,
            source: 'quick-add-custom',
            sections: data.sections,
          },
        },
      }),
    );
  }

  function setButtonState(button, selectedOption) {
    if (!button || !selectedOption) return;

    const isAvailable = selectedOption.dataset.available === 'true';
    button.dataset.variantId = selectedOption.value;
    button.disabled = !isAvailable;

    const fullText = button.querySelector('.full-add-to-cart-text');
    const smallText = button.querySelector('.small-add-to-cart-text');

    if (isAvailable) {
      if (fullText) fullText.textContent = window.Theme?.translations?.addToCart || 'Ajouter au panier';
      if (smallText) smallText.textContent = window.Theme?.translations?.add || 'Ajouter';
    } else if (fullText) {
      fullText.textContent = window.Theme?.translations?.unavailable || 'Indisponible';
    }
  }

  function showVariantMedia(component, selectedOption) {
    const productCard = component?.closest('product-card');
    const gallery = productCard?.querySelector('product-card-media-gallery');
    const mediaId = selectedOption?.dataset.variantMediaId;
    const mediaUrl = selectedOption?.dataset.variantMediaUrl;
    if (!gallery || !mediaId || !mediaUrl) return;

    const sliderComponent = gallery.querySelector('slider-component');
    if (sliderComponent?.slider) {
      const slides = Array.from(gallery.querySelectorAll('.splide__list > .splide__slide')).filter(
        (slide) => !slide.classList.contains('splide__slide--clone'),
      );
      const targetIndex = slides.findIndex((slide) => slide.dataset.mediaId === mediaId);
      if (targetIndex !== -1) sliderComponent.slider.go(targetIndex);
      return;
    }

    const image = gallery.querySelector('.product-card-media-gallery__media img');
    if (!image) return;
    image.src = mediaUrl;
    image.removeAttribute('srcset');
    image.alt = selectedOption.dataset.variantMediaAlt || '';

    if (gallery.dataset.mediaRatio === 'adapt' && selectedOption.dataset.variantMediaAspectRatio) {
      gallery.style.setProperty('--product-card-media-ratio', selectedOption.dataset.variantMediaAspectRatio);
      image.style.setProperty('--ratio', selectedOption.dataset.variantMediaAspectRatio);
    }
  }

  window.handleQuickAddVariantChange = (event) => {
    const select = event.target.closest?.(selectors.variantSelect);
    if (!select) return true;

    const component = select.closest(selectors.component);
    const selectedOption = select.options[select.selectedIndex];
    const variantInput = component?.querySelector(selectors.variantInput);
    const button = component?.querySelector(selectors.button);

    if (variantInput && selectedOption) variantInput.value = selectedOption.value;
    setButtonState(button, selectedOption);
    showVariantMedia(component, selectedOption);
    return true;
  };

  window.handleQuickAddSubmit = (event) => {
    const form = event.target.closest?.(selectors.form);
    if (!form) return true;
    if (event.__quickAddHandled) return false;
    event.__quickAddHandled = true;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation?.();

    const button = form.querySelector(selectors.button);
    const variantInput = form.querySelector(selectors.variantInput);
    const quantityInput = form.querySelector('[name="quantity"]');
    const variantId = variantInput?.value;
    const quantity = parseInt(quantityInput?.value, 10) || 1;

    if (!variantId || button?.disabled) return false;

    button?.classList.add('is-loading');

    (async () => {
      try {
        const response = await fetch(getCartAddUrl(form), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            items: [{ id: variantId, quantity }],
            sections: getSections().join(','),
          }),
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.description || data.message || 'Impossible d’ajouter ce produit au panier');
        }

        dispatchCartUpdated(data, quantity);
      } catch (error) {
        console.error('Quick add error:', error);
        document.dispatchEvent(
          new CustomEvent('toast:open', {
            detail: { type: 'error', message: error.message || error },
          }),
        );
      } finally {
        button?.classList.remove('is-loading');
      }
    })();

    return false;
  };

  document.addEventListener('change', window.handleQuickAddVariantChange);

  document.addEventListener('submit', window.handleQuickAddSubmit, true);
})();
